import { render, staticRenderFns } from "./TaskNavigationComponent.vue?vue&type=template&id=0c72391c&scoped=true"
import script from "./TaskNavigationComponent.vue?vue&type=script&lang=js"
export * from "./TaskNavigationComponent.vue?vue&type=script&lang=js"
import style0 from "./TaskNavigationComponent.vue?vue&type=style&index=0&id=0c72391c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72391c",
  null
  
)

export default component.exports